import * as React from "react";
import { Path, Rect, G, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const AXIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="AX" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#0061C1"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#D21034"
          stroke="#FFCE00"
          strokeWidth={0.8}
          d="M7.6-.4v4.8h8.8v3.2H7.6v4.8H4.4V7.6H-.4V4.4h4.8V-.4h3.2Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
